import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { RegistrationStepService } from "../registration-step.service";
import { QuestionRequest } from "../models/question-request.model";
import { MatDialog } from "@angular/material/dialog";
import { LoaderComponent } from "src/app/loader/loader.component";
import { ActionSheetController } from "@ionic/angular";
import { TranslocoService } from "@ngneat/transloco";
import { SpecialCategoryService } from "src/app/special-category.service";

@Component({
  selector: "app-qs-mh",
  templateUrl: "./qs-mh.component.html",
  styleUrls: ['../registration-step.component.scss']
})
export class QsMHComponent implements OnInit {

  questionCode: string = 'Q_MH';
  @Input() activeLang: string = "";
  @Output() proceedNext = new EventEmitter();

  // UI + Data variables
  uploadFileVisible: boolean = false;
  fileObj: File;
  selectedImage: string = '';
  errorMessageVisible: boolean = false;
  errorMessage: string = '';
  proceedEnabled: boolean = false;
  dirtyForm: boolean = false;

  fileBase64: string | ArrayBuffer;
  options: any[] = [];
  selectedCategory: string | null = null;

  registrationNo: string = '';
  surveyEnrollmentNo: string = '';

  progressSpinnerDialog: any = null;

  constructor(
    private registrationStepService: RegistrationStepService,
    private dialog: MatDialog,
    public actionSheetController: ActionSheetController,
    private translocoService: TranslocoService,
    private specialCategoryService: SpecialCategoryService
  ) { }

  // Categories that NEVER need file upload
  noFileCategories = [
    'Construction Workers',
    'Street Vendors',
    'Senior Citizens',
    'None Of The Above'
  ];

  ngOnInit() {

    // Load special category options
    this.specialCategoryService.getOptions().subscribe(data => {
      this.options = data;
    });

    // EDIT MODE HANDLING
    if (localStorage.getItem("editQuestionCode") === this.questionCode) {

      this.displayProgressSpinner();

      this.registrationStepService.fetchQuestionDetail(this.questionCode)
        .subscribe((data) => {

          this.closeProgressSpinner();

          if (data.status === "SUCCESS" ){
            if(data.specialCategoryResponse) {

            this.selectedCategory = data.specialCategoryResponse.answer;

            // If nothing selected earlier
            if (!this.selectedCategory) {
              this.uploadFileVisible = false;
              this.evaluateProceed();
              return;
            }

            // If selected category does NOT require file
            if (this.noFileCategories.includes(this.selectedCategory)) {

              this.uploadFileVisible = false;
              this.selectedImage = "";
              this.fileBase64 = null;

              this.evaluateProceed();
              return;
            }

            // For file-required categories → load preview from server
            this.fetchSpecialCategoryCertificate();

          }
        }else {
            this.registrationStepService.showErrorMessage(data.errorMessage, true);
          }
        }, error => {
          this.closeProgressSpinner();
          this.registrationStepService.frontendWarningToast("error-network-related-issue", true);
        });
    }
  }

  // Fetch uploaded certificate in edit mode
  fetchSpecialCategoryCertificate() {
    this.registrationStepService.fetchQuestionDoc(this.questionCode)
      .subscribe((data) => {

        if (data.status === "SUCCESS" && data.fileBase64) {

          const byteArray = new Uint8Array(
            atob(data.fileBase64).split("").map(c => c.charCodeAt(0))
          );
          const blob = new Blob([byteArray], { type: "image/png" });

          this.uploadFileVisible = true;
          this.selectedImage = URL.createObjectURL(blob);
          this.fileBase64 = data.fileBase64;

        } else {
          this.uploadFileVisible = false;
          this.selectedImage = "";
        }

        this.evaluateProceed();

      }, error => {
        this.uploadFileVisible = false;
        this.selectedImage = "";
      });
  }

  // When radio (category) is changed
  radioButtonClicked(event) {

    this.dirtyForm = true;

    // Reset previous file and validation state
    this.errorMessageVisible = false;
    this.errorMessage = '';
    this.selectedImage = '';
    this.fileBase64 = null;
    this.fileObj = null;

    // CASE 1: Categories that DO NOT require file
    if (this.noFileCategories.includes(this.selectedCategory)) {

      this.uploadFileVisible = false;

      if (this.selectedCategory === "Senior Citizens") {
        this.validateSeniorCitizen();
      }

      this.evaluateProceed();
      return;
    }

    // CASE 2: All other categories → require file
    this.uploadFileVisible = true;
    this.evaluateProceed();
  }

  validateSeniorCitizen() {
  this.registrationStepService.validateSeniorCitizen()
    .subscribe((response: any) => {

      if (response.status === 'SUCCESS' && response.exists) {

        this.errorMessageVisible = false;
        this.proceedEnabled = true;

      } else {

        // 🔥 ALERT ADDED BACK (this was missing)
        const msg = this.translocoService.translate('alerts.notASenior');
        alert(msg);

        this.errorMessageVisible = true;
        this.errorMessage = this.translocoService.translate('errors.notASenior');
        this.proceedEnabled = false;
      }

    }, error => {

      this.errorMessageVisible = true;
      this.errorMessage = this.translocoService.translate('errors.errorValidatingConstructionWorkersRegistrationNumber');
      this.proceedEnabled = false;

    });
}


  // File selected
  setFileObj(event) {
    this.fileObj = event;
    this.dirtyForm = true;

    const reader = new FileReader();
    reader.readAsDataURL(this.fileObj);
    reader.onload = () => {
      this.fileBase64 = reader.result;
      this.evaluateProceed();
    };
  }

  setSelectedImage(event) {
    this.selectedImage = event;
  }

  evaluateProceed() {

    this.proceedEnabled = false;

    // Categories that always allow proceed
    if (this.selectedCategory === 'None Of The Above' || this.selectedCategory === 'Senior Citizens') {
      this.proceedEnabled = true;
    }

    // Construction Workers
    else if (this.selectedCategory === 'Construction Workers') {
      if (this.registrationNo && !this.errorMessageVisible)
        this.proceedEnabled = true;
    }

    // Street Vendors
    else if (this.selectedCategory === 'Street Vendors') {
      if (this.surveyEnrollmentNo && !this.errorMessageVisible)
        this.proceedEnabled = true;
    }

    // Categories that need file
    else {
      if (this.selectedImage || this.fileBase64)
        this.proceedEnabled = true;
    }

    return this.proceedEnabled;
  }

  // onIdentificationNumberChange() {

  //   this.errorMessageVisible = false;

  //   if (this.selectedCategory === 'Construction Workers') {

  //     if (this.registrationNo.trim().length > 0) {

  //       this.registrationStepService
  //         .validateConstructionWorkersRegistrationNumber(this.registrationNo)
  //         .subscribe((response: any) => {

  //           if (response.status === 'SUCCESS' && response.exists) {
  //             this.errorMessageVisible = false;
  //             this.proceedEnabled = true;
  //           } else {
  //             this.errorMessageVisible = true;
  //             this.errorMessage = this.translocoService.translate('errors.invalidConstructionWorkersRegistrationNumber');
  //             this.proceedEnabled = false;
  //           }

  //         }, error => {
  //           this.errorMessageVisible = true;
  //           this.errorMessage = this.translocoService.translate('errors.errorValidatingConstructionWorkersRegistrationNumber');
  //         });
  //     }

  //   } else if (this.selectedCategory === 'Street Vendors') {

  //     if (this.surveyEnrollmentNo.trim().length > 0) {
  //       this.registrationStepService
  //         .validateStreetVendorsSurveyEnrollmentNumberNumber(this.surveyEnrollmentNo)
  //         .subscribe((response: any) => {

  //           if (response.status === 'SUCCESS' && response.exists) {
  //             this.errorMessageVisible = false;
  //             this.proceedEnabled = true;
  //           } else {
  //             this.errorMessageVisible = true;
  //             this.errorMessage = this.translocoService.translate('errors.invalidStreetVendorsSurveyEnrollmentNumber');
  //             this.proceedEnabled = false;
  //           }

  //         }, error => {
  //           this.errorMessageVisible = true;
  //           this.errorMessage = this.translocoService.translate('errors.errorValidatingStreetVendorsSurveyEnrollmentNumber');
  //         });
  //     }
  //   }

  // }

  onIdentificationNumberChange() {

  this.errorMessageVisible = false;

  // 🔥 ALWAYS FORCE UPPERCASE FIRST
  if (this.selectedCategory === 'Construction Workers') {
    this.registrationNo = this.registrationNo.toUpperCase().trim();
  }

  if (this.selectedCategory === 'Street Vendors') {
    this.surveyEnrollmentNo = this.surveyEnrollmentNo.toUpperCase().trim();
  }

  if (this.selectedCategory === 'Construction Workers') {

    if (this.registrationNo.trim().length > 0) {

      this.registrationStepService
        .validateConstructionWorkersRegistrationNumber(this.registrationNo)
        .subscribe((response: any) => {

          if (response.status === 'SUCCESS' && response.exists) {
            this.errorMessageVisible = false;
            this.proceedEnabled = true;
          } else {
            this.errorMessageVisible = true;
            this.errorMessage = this.translocoService.translate('errors.invalidConstructionWorkersRegistrationNumber');
            this.proceedEnabled = false;
          }

        }, error => {
          this.errorMessageVisible = true;
          this.errorMessage = this.translocoService.translate('errors.errorValidatingConstructionWorkersRegistrationNumber');
        });
    }

  } else if (this.selectedCategory === 'Street Vendors') {

    if (this.surveyEnrollmentNo.trim().length > 0) {

      this.registrationStepService
        .validateStreetVendorsSurveyEnrollmentNumberNumber(this.surveyEnrollmentNo)
        .subscribe((response: any) => {

          if (response.status === 'SUCCESS' && response.exists) {
            this.errorMessageVisible = false;
            this.proceedEnabled = true;
          } else {
            this.errorMessageVisible = true;
            this.errorMessage = this.translocoService.translate('errors.invalidStreetVendorsSurveyEnrollmentNumber');
            this.proceedEnabled = false;
          }

        }, error => {
          this.errorMessageVisible = true;
          this.errorMessage = this.translocoService.translate('errors.errorValidatingStreetVendorsSurveyEnrollmentNumber');
        });
    }
  }
}


  async proceed() {

    if (this.dirtyForm) {

      if (this.evaluateProceed()) {

        this.displayProgressSpinner();

        let request: QuestionRequest = {
          specialCategoryRequest: {
            answer: this.selectedCategory,
            fileBase64: this.fileBase64,
            registrationNo: this.registrationNo,
            surveyEnrollmentNo: this.surveyEnrollmentNo
          }
        };

        this.registrationStepService.saveQuestion(this.questionCode, request)
          .subscribe((data) => {

            this.closeProgressSpinner();

            if (data.status === 'SUCCESS') {
              localStorage.removeItem("editQuestionCode");
              this.proceedNext.emit();
            } else {
              this.registrationStepService.showErrorMessage(data.errorMessage, true);
            }

          }, error => {
            this.closeProgressSpinner();
            this.registrationStepService.frontendWarningToast("error-network-related-issue", true);
          });

      } else {
        this.registrationStepService.frontendWarningToast("error-mandatory-fields", false);
      }

    } else {

      this.displayProgressSpinner();

      this.registrationStepService.proceedWithoutSave(this.questionCode)
        .subscribe((data) => {

          this.closeProgressSpinner();

          if (data.status === 'SUCCESS') {
            localStorage.removeItem("editQuestionCode");
            this.proceedNext.emit();
          }

        }, error => {
          this.closeProgressSpinner();
          localStorage.removeItem("editQuestionCode");
          this.proceedNext.emit();
        });
    }
  }

  // Loader handling
  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(LoaderComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  async closeProgressSpinner() {
    if (this.progressSpinnerDialog) {
      this.progressSpinnerDialog.close();
    }
  }

  formatRegistrationNo(value: string) {
  this.registrationNo = value.toUpperCase().trim();   // Forces uppercase
}

formatSurveyEnrollmentNo(value: string) {
  this.surveyEnrollmentNo = value.toUpperCase().trim();  // Forces uppercase
}
}
